module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-fog2-fill-11ead95d.svg";